export const PROJECTS = [
  {
    slug: "essence",
    name: "L'Essence — Restaurant gastronomique",
    shortName: "L'Essence",
    category: "Restauration",
    location: "La Rochelle",
    siteType: "Site vitrine avec réservation",
    description: "Gastronomie française contemporaine à La Rochelle. Ambiance feutrée, réservation en ligne, carte immersive.",
    image: "/creation-site-internet-restaurant.webp",
    alt: "Site internet moderne créé pour un restaurant gastronomique à La Rochelle",
    gallery: ["/creation-site-internet-restaurant-2.webp", "/creation-site-internet-restaurant-3.webp"],
    url: "https://delorme-michelin.preview.emergentagent.com/",
    size: "large",
    seoTitle: "Création site internet restaurant gastronomique — L'Essence, La Rochelle | Les Amis du Web",
    seoDescription:
      "Découvrez L'Essence, site internet de restaurant gastronomique créé sur mesure : réservation de table en ligne, carte interactive, design élégant noir et or. Un exemple de création de site pour la restauration.",
    features: ["Réservation de table en ligne", "Carte & menus interactifs", "Galerie immersive", "Présentation du chef et de la maison"],
    story:
      "Pour un restaurant gastronomique, tout se joue sur l'émotion. Nous avons construit une expérience sombre et feutrée, portée par une typographie serif élégante et des visuels pleine largeur, pour retranscrire en ligne l'atmosphère de la salle.",
    approach:
      "Direction artistique noir et or, navigation minimaliste, mise en scène des plats et du geste du chef. Le parcours guide naturellement le visiteur vers la réservation de table, sur ordinateur comme sur mobile.",
  },
  {
    slug: "villa-azur",
    name: "Villa Azur — Maison de location",
    shortName: "Villa Azur",
    category: "Location & Immobilier",
    location: "Île de Ré",
    siteType: "Site vitrine avec disponibilités",
    description: "Une parenthèse privée face à l'océan. Visite immersive, disponibilités et réservation.",
    image: "/site-internet-villa-location.webp",
    alt: "Site internet élégant créé pour une villa de location face à l'océan",
    gallery: ["/site-internet-villa-location-2.webp", "/site-internet-villa-location-3.webp"],
    url: "https://preview-azur.preview.emergentagent.com/",
    size: "small",
    seoTitle: "Création site internet location de villa — Villa Azur, Île de Ré | Les Amis du Web",
    seoDescription:
      "Villa Azur, site internet de maison de location créé sur mesure : visite immersive, calendrier des disponibilités, version bilingue. Un exemple de création de site pour la location saisonnière et l'immobilier.",
    features: ["Visite immersive de la villa", "Journée type illustrée", "Calendrier des disponibilités", "Bilingue français / anglais"],
    story:
      "Louer une villa haut de gamme, c'est d'abord se projeter. Le site déroule une visite immersive de la maison et de ses espaces, rythmée par de grandes photographies lumineuses face à l'océan.",
    approach:
      "Palette claire et solaire, typographie éditoriale, storytelling d'une journée à la villa. Chaque section rapproche le visiteur de la demande de réservation, avec une version anglaise pour la clientèle internationale.",
  },
  {
    slug: "atelier-coiffure",
    name: "L'Atelier — Salon de coiffure",
    shortName: "L'Atelier",
    category: "Beauté & Coiffure",
    location: "Paris",
    siteType: "Site vitrine avec prise de rendez-vous",
    description: "Maison de beauté parisienne haut de gamme. Prestations, avant/après et prise de rendez-vous.",
    image: "/creation-site-internet-coiffeur.webp",
    alt: "Site internet haut de gamme créé pour un salon de coiffure parisien",
    gallery: ["/creation-site-internet-coiffeur-2.webp", "/creation-site-internet-coiffeur-3.webp"],
    url: "https://coiffure-luxe-paris.preview.emergentagent.com/",
    size: "small",
    seoTitle: "Création site internet salon de coiffure — L'Atelier, Paris | Les Amis du Web",
    seoDescription:
      "L'Atelier, site internet de salon de coiffure haut de gamme créé sur mesure : prise de rendez-vous en ligne, galerie avant/après, prestations et tarifs. Un exemple de création de site pour la beauté et la coiffure.",
    features: ["Prise de rendez-vous en ligne", "Galerie avant / après", "Carte des prestations et tarifs", "Mise en avant du savoir-faire"],
    story:
      "Un salon haut de gamme mérite mieux qu'une simple liste de prix. Nous avons imaginé une maison de beauté digitale : ambiance tamisée, matières chaudes, photographies soignées et avant/après qui prouvent le geste.",
    approach:
      "Direction artistique sombre et dorée inspirée des maisons parisiennes, typographie serif raffinée, parcours orienté vers la prise de rendez-vous. Le site respire le même luxe que le salon lui-même.",
  },
  {
    slug: "atelier-renovation",
    name: "Atelier Rénovation",
    shortName: "Atelier Rénovation",
    category: "Bâtiment & Rénovation",
    location: "La Rochelle",
    siteType: "Site vitrine avec demande de devis",
    description: "Rénovation intérieure d'exception. Réalisations, avant/après et demande de devis.",
    image: "/site-internet-renovation-interieure.webp",
    alt: "Site internet créé pour une entreprise de rénovation intérieure d'exception",
    gallery: ["/site-internet-renovation-interieure-2.webp", "/site-internet-renovation-interieure-3.webp"],
    url: "https://renovation-premium-2.preview.emergentagent.com/",
    size: "small",
    seoTitle: "Création site internet artisan rénovation — Atelier Rénovation, La Rochelle | Les Amis du Web",
    seoDescription:
      "Atelier Rénovation, site internet d'entreprise de rénovation intérieure créé sur mesure : portfolio de chantiers, avant/après, demande de devis en ligne. Un exemple de création de site pour le bâtiment et l'artisanat.",
    features: ["Portfolio de réalisations", "Comparateur avant / après", "Présentation de la méthode en 4 étapes", "Demande de devis en ligne"],
    story:
      "Dans la rénovation, la preuve fait tout. Le site met les chantiers au premier plan : grandes images d'intérieurs, avant/après spectaculaires et méthode expliquée pas à pas pour rassurer les futurs clients.",
    approach:
      "Palette minérale claire, typographie affirmée, grille éditoriale aérée. Un design qui évoque la précision de l'artisan et conduit naturellement à la demande de devis.",
  },
  {
    slug: "noire-vtc",
    name: "Noiré — Chauffeur privé VTC",
    shortName: "Noiré",
    category: "Transport & VTC",
    location: "Paris",
    siteType: "Site vitrine avec réservation de trajet",
    description: "Voyagez autrement. Flotte, destinations et réservation de trajets premium.",
    image: "/site-internet-chauffeur-vtc.webp",
    alt: "Site internet premium créé pour un chauffeur privé VTC à Paris",
    gallery: ["/site-internet-chauffeur-vtc-2.webp", "/site-internet-chauffeur-vtc-3.webp"],
    url: "https://noir-experience-8.preview.emergentagent.com/",
    size: "small",
    seoTitle: "Création site internet chauffeur privé VTC — Noiré, Paris | Les Amis du Web",
    seoDescription:
      "Noiré, site internet de chauffeur privé VTC créé sur mesure : réservation de trajet en ligne, présentation de la flotte, ambiance premium. Un exemple de création de site pour le transport haut de gamme.",
    features: ["Réservation de trajet en ligne", "Présentation de la flotte", "Destinations & expérience à bord", "Avis clients"],
    story:
      "Pour un chauffeur privé haut de gamme, le site doit inspirer la même confiance qu'une berline impeccable. Ambiance nocturne parisienne, noir profond et touches dorées : l'expérience commence avant même de monter à bord.",
    approach:
      "Direction artistique cinématographique, mise en avant du confort et de la ponctualité, réservation accessible à chaque étape du parcours. Un site pensé pour une clientèle exigeante.",
  },
  {
    slug: "aqua-pro-plombier",
    name: "Aqua Pro — Plombier à La Rochelle",
    shortName: "Aqua Pro",
    category: "Artisan & Plomberie",
    location: "La Rochelle",
    siteType: "Site vitrine avec demande de devis",
    description: "Plombier local à La Rochelle. Dépannage, avant/après interactifs, zone d'intervention et devis gratuit en ligne.",
    image: "/creation-site-internet-plombier.webp",
    alt: "Site internet moderne créé pour un plombier à La Rochelle",
    gallery: ["/creation-site-internet-plombier-2.webp", "/creation-site-internet-plombier-3.webp"],
    url: "https://aqua-services-9.preview.emergentagent.com/",
    size: "large",
    seoTitle: "Création site internet plombier — Aqua Pro, La Rochelle | Les Amis du Web",
    seoDescription:
      "Aqua Pro, site internet de plombier créé sur mesure : demande de devis en ligne, avant/après interactifs, zone d'intervention, FAQ et avis clients. Un exemple de création de site pour artisan.",
    features: ["Demande de devis gratuit en ligne", "Avant / après interactifs des chantiers", "Zone d'intervention détaillée", "Appel en un clic depuis mobile", "FAQ et avis clients"],
    story:
      "Pour un plombier, tout se joue sur la confiance et la rapidité : le visiteur a souvent un problème urgent et veut un artisan sérieux, joignable immédiatement. Le site met en avant l'appel en un clic, le devis gratuit et les preuves concrètes du savoir-faire.",
    approach:
      "Design bleu profond et professionnel, avant/après interactifs des chantiers, zone d'intervention autour de La Rochelle et parcours pensé pour convertir : chaque section ramène vers l'appel ou la demande de devis.",
  },
];

export const BENEFITS = [
  { icon: "Search", title: "Plus de visibilité sur Google", text: "Votre activité ressort sur les recherches qui comptent pour vous." },
  { icon: "MessageSquare", title: "Plus de demandes de contact", text: "Un site pensé pour transformer les visiteurs en clients." },
  { icon: "Award", title: "Une image professionnelle", text: "Un design moderne qui inspire le sérieux dès la première seconde." },
  { icon: "Smartphone", title: "Une expérience parfaite sur mobile", text: "Parfaitement fluide sur téléphone, là où sont vos clients." },
  { icon: "Clock", title: "Une présence 24h/24", text: "Votre vitrine travaille pour vous, même quand vous dormez." },
  { icon: "CalendarCheck", title: "Réservations & rendez-vous", text: "Vos clients réservent ou prennent rendez-vous en ligne." },
  { icon: "ShieldCheck", title: "Plus de confiance", text: "Un site soigné rassure et crédibilise votre activité." },
];

export const MANIFESTE = [
  {
    num: "01",
    label: "Sans engagement",
    title: "L'aperçu gratuit",
    text: "Avant même de vous engager, nous créons un aperçu de ce que pourrait être votre site internet — gratuitement. Vous visualisez le résultat, et si ça vous plaît, nous nous penchons sérieusement sur le sujet. Zéro risque, zéro engagement.",
    image: "/manifeste-apercu.webp",
  },
  {
    num: "02",
    label: "Visibilité Google",
    title: "Le référencement SEO",
    text: "Vous voulez être trouvé sur Google avec des mots précis ? Dites-nous lesquels. Nous ferons tout pour répondre à vos envies de référencement : structure optimisée, mots-clés ciblés, performance. Votre visibilité est notre priorité.",
    image: "/manifeste-seo.webp",
  },
  {
    num: "03",
    label: "Adaptation totale",
    title: "Polyvalent, tous domaines",
    text: "Restaurant, artisan, boutique, cabinet, association… Nous nous adaptons à tous les domaines pour créer le site qui vous ressemble. Chaque projet est unique, chaque design est pensé pour votre activité.",
    image: "/manifeste-domaines.webp",
  },
];

export const STEPS = [
  { num: "01", title: "Vous nous expliquez votre projet", text: "Vous décrivez votre activité et vos envies en quelques mots via le formulaire ou par email. Rapide et sans engagement.", highlight: false },
  { num: "02", title: "Nous créons votre aperçu gratuit", text: "Nous concevons gratuitement un premier aperçu de votre futur site, adapté à votre activité. Aucun paiement nécessaire.", highlight: true },
  { num: "03", title: "Vous découvrez votre futur site", text: "Vous visualisez le résultat avant de décider. Si ça vous plaît, on continue. Sinon, vous ne devez rien.", highlight: false },
  { num: "04", title: "Nous construisons et optimisons", text: "Design final, contenus, performance et SEO sur vos mots-clés : nous développons votre site complet, sur mesure.", highlight: false },
  { num: "05", title: "Votre site est mis en ligne", text: "Hébergé, entretenu et suivi. Mises à jour et modifications incluses dans l'abonnement mensuel.", highlight: false },
];

export const SEO_POINTS = [
  { icon: "Code2", title: "Structure technique propre", text: "Un code sain, des balises structurées et une architecture lisible par Google." },
  { icon: "Gauge", title: "Vitesse & performance", text: "Des pages rapides, optimisées et légères — un critère majeur de référencement." },
  { icon: "Smartphone", title: "100 % responsive", text: "Une expérience parfaite sur mobile, tablette et ordinateur." },
  { icon: "Target", title: "Mots-clés ciblés", text: "Un contenu optimisé autour des recherches réelles de vos futurs clients." },
  { icon: "MapPin", title: "Référencement local", text: "Quand c'est pertinent, votre activité ressort dans votre zone géographique." },
  { icon: "FileText", title: "Contenu optimisé", text: "Des textes pensés pour vos visiteurs et pour les moteurs de recherche." },
];

export const TESTIMONIALS = [
  {
    quote: "L'aperçu gratuit m'a convaincue immédiatement : j'ai vu mon site avant même de m'engager. Le résultat final est élégant, rapide, et mes patients prennent rendez-vous en ligne facilement.",
    name: "Dr Lisa M.",
    role: "Chirurgien-dentiste, La Rochelle",
  },
  {
    quote: "Je ne connaissais rien aux sites internet. L'équipe a tout géré de A à Z et je suis maintenant visible sur Google avec les mots-clés de mon métier. Un vrai plus pour mon activité.",
    name: "Julien R.",
    role: "Artisan menuisier",
  },
  {
    quote: "Réactifs, à l'écoute et passionnés. L'abonnement mensuel me permet de faire évoluer mon site sans me soucier de la technique : je demande, c'est fait.",
    name: "Sophie T.",
    role: "Gérante de boutique",
  },
];

export const FAQ = [
  {
    q: "Quels sont les délais de création d'un site internet ?",
    a: "L'aperçu gratuit est généralement prêt en quelques jours. Une fois validé, le site complet est développé en 2 à 4 semaines selon la complexité du projet (nombre de pages, fonctionnalités, contenus).",
  },
  {
    q: "L'aperçu gratuit est-il vraiment sans engagement ?",
    a: "Oui, totalement. Nous créons un premier aperçu de votre futur site sans aucun paiement ni obligation. Vous voyez le résultat avant de décider. Si cela ne vous convient pas, vous ne devez rien.",
  },
  {
    q: "Qui fournit les textes et les photos du site ?",
    a: "Vous nous transmettez ce que vous avez (photos, logo, descriptions) et nous nous chargeons du reste : rédaction optimisée SEO, mise en forme et sélection de visuels cohérents avec votre image.",
  },
  {
    q: "Que comprend l'abonnement mensuel de 65€ ?",
    a: "L'hébergement de votre site, son entretien technique, les mises à jour de pages et les modifications que vous demandez. Votre site vit et évolue avec votre activité, sans surcoût caché.",
  },
  {
    q: "Puis-je résilier l'abonnement quand je veux ?",
    a: "Oui. L'abonnement est sans engagement de durée : vous pouvez le résilier à tout moment, simplement en nous prévenant.",
  },
  {
    q: "Serai-je visible sur Google avec mes mots-clés ?",
    a: "Nous construisons chaque site avec une base solide pour être visible sur Google : structure technique propre, vitesse, contenu optimisé et mots-clés ciblés. Le référencement naturel prend du temps, mais votre site part avec toutes les bonnes fondations. Nous ne promettons jamais une première place garantie — personne ne le peut sérieusement.",
  },
];

export const NAV_LINKS = [
  { label: "Accueil", anchor: "accueil" },
  { label: "Aperçu gratuit", anchor: "apercu" },
  { label: "Réalisations", anchor: "realisations" },
  { label: "SEO", anchor: "seo" },
  { label: "Services", anchor: "services" },
  { label: "Tarifs", anchor: "tarifs" },
  { label: "L'entreprise", anchor: "entreprise" },
  { label: "Conseils", to: "/conseils" },
];

export const CONTACT_EMAIL = "contact@lesamisduweb.fr";
